import React from 'react'

import { CommonSvgContent } from "./CommonSvgContent"

import "./../assets/scss/Header.scss";


export const Header = (props) => {

    return(

      <div className="header">
        <div className={`vol ${props.sound ? "active" : ""}`}>
          <span className="label"><CommonSvgContent stringToRet="voloff" /></span>
          <label className="switch">
            <input type="checkbox" defaultChecked={props.lang === 'ita' ? false : true} onChange={props.onChangeSound} />
            <span className="slider round"></span>
          </label>
          <span className="label"><CommonSvgContent stringToRet="volon" /></span>
        </div>
      </div>

    )
}
